import { createFileRoute } from '@tanstack/react-router';
import { MonitoringDebug } from '~/components/Debug/MonitoringDebug';

export const Route = createFileRoute('/debug/monitoring')({
  component: MonitoringDebug,
});
